import React, { useEffect, useState } from 'react';
import { ReactSession } from "react-client-session";
import Header from './Header'
import Contenido from './Contenido';
import Login from './Login/Login';
import './css/Sidebar.css'
import ContextGlobal from './Context/ContextGlobal';
import MenuOpciones from './MenuOpciones';

function Principal() {
    const [login, setLogin] = useState(false);
    const [regional, setRegional] = useState('');
    useEffect(() => {
        var tiempoActivo = localStorage.getItem("timeInit");
        if (tiempoActivo == null) {
            localStorage.clear()
            setLogin(false);
        }else{
            var tiempoActual = new Date().getTime();
            if(((tiempoActual-tiempoActivo)/(1000*60*60*24))>=2){
                localStorage.clear()
                setLogin(false);
            }
        }
    }, [])
    useEffect(() => {
        setRegional(ReactSession.get("regional"));
    }, [login]);
    if (login) {
        return (
            <ContextGlobal>
                <Header login={login} />
                <Contenido regional={regional} />
                <MenuOpciones setLogin={setLogin} />
            </ContextGlobal>
        );
    } else {
        if (ReactSession.get("idSession") === undefined) {
            return (
                <ContextGlobal>
                    <Header login={login} />
                    <Login setLoginAcceso={setLogin} />
                </ContextGlobal>
            );
        } else {
            setLogin(true);
        }
    }
}
export default Principal;